module.exports = __webpack_public_path__ + "static/media/project1.d4cd806d.jpg";